var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2656 8.28906L13.7656 12.7891L14.5859 13.6094C14.6797 13.7031 14.75 13.8438 14.75 13.9844C14.75 14.2656 14.4922 14.5 14.2109 14.5H13.5312L11 11.9688V11.2891C11 11.0078 11.2344 10.75 11.5156 10.75C11.6562 10.75 11.7969 10.8203 11.8906 10.9141L12.7109 11.7344L17.2109 7.23438C17.4922 6.92969 17.9844 6.92969 18.2656 7.23438C18.5703 7.51562 18.5703 8.00781 18.2656 8.28906ZM12.9922 15.2969C13.0625 16.3047 12.7109 17.2891 11.9844 18.0156C11.3516 18.6484 10.4844 19 9.57031 19H5.51562C5.21094 19 5 18.7891 5 18.4844C5 18.3438 5.04688 18.2031 5.16406 18.1094L8.11719 15.4375C8.21094 15.3438 8.11719 15.2031 8 15.25L6.80469 15.8594C6.66406 15.9297 6.5 15.8125 6.5 15.6719C6.5 14.9219 6.78125 14.2188 7.29688 13.7031L7.48438 13.5156C8.21094 12.7891 9.19531 12.4375 10.2031 12.5078L12.9922 15.2969Z",
    fill: "#0076A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeddle);
export default __webpack_public_path__ + "static/media/peddle.d5da0ce3bdfa09552ac3ae73bbcdb1d4.svg";
export { ForwardRef as ReactComponent };